import { ClassRM } from "models/RM"
import { useAlert } from "components/Alerts/hooks"
import { useDispatch } from "react-redux"
import { alerts } from "keys"
import { reset } from "redux-form"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { createClassFetch } from "store/middlewares/testTakers.crud"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { application, pulldowns, testTakerRQ } from "store/hooks"
import { useSelector } from "react-redux"
import { getUserDataFetch } from "store/middlewares/user.crud"
import { secretStorage } from "config"
import qc from "keys/queryClient"
import { useParams } from "react-router-dom"

const useCreateClass = () => {
    const formName = "createClass"
    const queryClient = useQueryClient()
    const setAppData = application.useSetAppData()
    const handleGrade = pulldowns.useHandleGrade()
    const { headerFilters } = useSelector(state => state.header)
    const { setAlerts } = useAlert()
    const { affiliationID } = useParams()
    const dispatch = useDispatch()

    const userData = useQuery({
        queryKey: [qc.userData],
        queryFn: async () => {
            const { data } = await getUserDataFetch()
            const user = secretStorage.getItem("user")
            secretStorage.setItem("user", { ...user, user_data: data })
            await setAppData(data)
            handleGrade(headerFilters)
            return data
        },
        enabled: false
    })

    const { mutateAsync: createClassRQ } = useMutation({
        mutationFn: createClassFetch,
        onSuccess: async () => {
            userData.refetch()
            setAlerts(alerts.createClass2, false)

            queryClient.invalidateQueries({ queryKey: [qc.affiliationGrades, affiliationID] })

            toast(" הכיתה נוצרה בהצלחה", toastConfig)
            dispatch(reset(formName))
        },
        onError: ({ response }) => {
            const { data } = response
            if (data.name == "A class with this name and this school_year already exists.")
                toast.error("כיתה זו עבור שנת לימודים זו כבר קיימת במערכת", toastConfig)
        }
    })

    const createClass = async (values) => {
        const classRM = new ClassRM(values)
        await createClassRQ(classRM)
    }

    return createClass
}

export default useCreateClass